import script from "./Form.vue?vue&type=script&lang=ts&setup=true"
export * from "./Form.vue?vue&type=script&lang=ts&setup=true"

import "./Form.vue?vue&type=style&index=0&id=5a8289d8&lang=scss"

const __exports__ = script;

export default __exports__